import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'nova-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatButtonModule, MatIconModule, MatSelectModule]
})
export class PaginationComponent {
    pages: number[] = [];
    @Input() currentPage = 1;

    @Input() set resetPageToken(_: number) {
        this.currentPage = 1;
    }

    get pageCount() {
        return this.pages.length;
    }

    @Input() set pageCount(value: number) {
        if (value <= 0) {
            this.pages = [];
            this.currentPage = 1;
            return;
        }

        // Only rebuild the pages array when the count actually changes, as an optimization
        // to avoid creating a new array on every change detection cycle.
        if (value !== this.pageCount) {
            this.pages = Array.from({ length: value }, (_, i) => i + 1);
        }

        if (this.currentPage < 1) {
            this.currentPage = 1;
        } else if (this.currentPage > value) {
            this.currentPage = value;
        }
    }

    @Output() onPageSelected = new EventEmitter<number>();

    loadPage(pageNumber: number) {
        if (pageNumber <= this.pageCount && pageNumber >= 1) {
            this.currentPage = pageNumber;
            this.onPageSelected.emit(this.currentPage);
        }
    }
}
